__turbopack_context__.v({
  "app_light_theme": "variants-group-module-scss-module__Im5OZa__app_light_theme",
  "current": "variants-group-module-scss-module__Im5OZa__current",
  "link": "variants-group-module-scss-module__Im5OZa__link",
  "outOfStock": "variants-group-module-scss-module__Im5OZa__outOfStock",
  "productVariantsTitle": "variants-group-module-scss-module__Im5OZa__productVariantsTitle",
});
